import { defineComponent as _defineComponent } from 'vue'
import { createCommentVNode as _createCommentVNode } from "vue"

import { computed, onMounted, watch } from 'vue'
import { useRoute, useRouter } from 'vue-router'

import i18n from '@/i18n'

import type { SidebarConfig } from '../types'


export default /*@__PURE__*/_defineComponent({
  __name: 'CoachingSidebar',
  emits: ["update:config"],
  setup(__props, { emit: __emit }) {

const emit = __emit

const router = useRouter()
const route = useRoute()

const isCurrent = (name: string) => {
  return route.name?.toString().startsWith(name)
}

const handleSubnavItemClick = (navItem: string, subnavItem: string) => {
  if (navItem === 'coaching') {
    if (subnavItem === 'sessions') {
      router.push({ name: 'coaching.sessions' })
    }
    if (subnavItem === 'pins') {
      router.push({ name: 'pins' })
    }
    if (subnavItem === 'quizzes') {
      router.push({ name: 'quizzes' })
    }
  }
}

const items = computed(() => [
  {
    children: i18n.t('routes.coaching.label.sessions'),
    key: 'sessions',
    isCurrent: isCurrent('coaching.session'),
    view: 'coaching',
  },
  {
    children: i18n.t('routes.coaching.label.pins'),
    key: 'pins',
    isCurrent: isCurrent('pins'),
    view: 'coaching',
  },
  {
    children: i18n.t('routes.coaching.label.quizzes'),
    key: 'quizzes',
    isCurrent: isCurrent('quizzes'),
    view: 'coaching',
  },
])

const config = computed(
  (): SidebarConfig => ({
    action: {
      tooltip: '',
      menuItems: [],
      onClick: () => {
        /* no-op */
      },
    },
    title: i18n.t('routes.coaching.type'),
    items: items.value,
    handleSubnavItemClick,
    handleSubnavItemActionClick: () => {
      /* no-op */
    },
    handleGroupActionClick: () => {
      /* no-op */
    },
  }),
)

// Emit initial config and watch for changes
onMounted(() => {
  emit('update:config', config.value)
})

// Watch for changes and emit updates
watch(config, (newConfig) => {
  emit('update:config', newConfig)
})

return (_ctx: any,_cache: any) => {
  return _createCommentVNode(" Renderless component ")
}
}

})